export default "__VITE_ASSET__Clkehp_A__"